
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { saveLogo } from '@/api/survey'
import { getCDNUrl } from '@/utils/cdn'

@Component<CompanyLogo>({})
export default class CompanyLogo extends Vue {
    @Prop(String)
    url

    isSaving = false
    uploadedUrl = null

    get src() {
        return getCDNUrl(this.uploadedUrl ?? this.url)
    }

    async upload(event: Event) {
        if (this.isSaving) {
            return
        }

        const files = (event.target as HTMLInputElement).files
        if (files && files[0]) {
            this.isSaving = true
            const { data } = await saveLogo(files[0], 'default', 'company')
            this.uploadedUrl = data.logo ?? this.url
            this.isSaving = false
        }
    }
}
